import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { careersSeo } from './Careers.seo';
import type { CareersProps } from './Careers.types';
import { CareersContact } from './CareersContact/CareersContact';
import { CurrentOpenings } from './CurrentOpenings/';
import { EmptyCurrentOpenings } from './EmptyCurrentOpenings';
import { Hero } from './Hero/Hero';
import { ImageSection } from './ImageSection';
import { KeyStrengths } from './KeyStrengths';
import { RecruitmentProcess } from './RecruitmentProcess/RecruitmentProcess';

export const CareersPage = ({ blogPosts, jobPosts }: CareersProps) => {
  const hasOffers = jobPosts && jobPosts?.length > 0;
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...careersSeo} />
      <Hero hasOffers={hasOffers} />
      <KeyStrengths />
      <ImageSection />
      {hasOffers ? (
        <CurrentOpenings model={jobPosts} />
      ) : (
        <EmptyCurrentOpenings />
      )}
      <RecruitmentProcess />
      <CareersContact color="orange" id="contact-form" />
      <NextHeadWithMeta />
    </Layout>
  );
};
